import { useQuery, QueryResult } from "@apollo/client";
// Api
import { GET_COUNTRIES } from "trading/api/queries";
import { Countries } from "trading/api/types/countries";

export const useGetCountries = (): QueryResult<Countries> => {
  const data = useQuery<Countries>(GET_COUNTRIES, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });
  return data;
};
